import React from 'react';
import {
  HStack,
  IconButton,
  Tooltip,
  Text,
} from '@chakra-ui/react';
import { AddIcon, MinusIcon, RepeatIcon } from '@chakra-ui/icons';
import { useFontSize } from '../../contexts/FontSizeContext';

const FontSizeControls = () => {
  const { increaseFontSize, decreaseFontSize, resetFontSize } = useFontSize();

  return (
    <HStack spacing={1}>
      <Text fontSize="sm" color="gray.500">Font:</Text>
      <Tooltip label="Decrease font size" placement="top">
        <IconButton
          icon={<MinusIcon />}
          size="sm"
          variant="ghost"
          onClick={decreaseFontSize}
          aria-label="Decrease font size"
        />
      </Tooltip>
      <Tooltip label="Reset font size" placement="top">
        <IconButton
          icon={<RepeatIcon />}
          size="sm"
          variant="ghost"
          onClick={resetFontSize}
          aria-label="Reset font size"
        />
      </Tooltip>
      <Tooltip label="Increase font size" placement="top">
        <IconButton
          icon={<AddIcon />}
          size="sm"
          variant="ghost"
          onClick={increaseFontSize}
          aria-label="Increase font size"
        />
      </Tooltip>
    </HStack>
  );
};

export default FontSizeControls;
